export default function ( title ) {
	window.gtag( 'event', title )
}


// WEBPACK FOOTER //
// ./src/components/GA/GA.js